import React from "react";
import { motion } from "framer-motion";
import { KineticText, EASE } from "../lib/motion";

// Reusable cinematic page header with parallax image band
export default function PageHero({ eyebrow, title, accent, image, subtitle }) {
  return (
    <section className="relative h-[60vh] min-h-[440px] flex items-center justify-center overflow-hidden">
      <motion.div
        initial={{ scale: 1.2 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1.6, ease: EASE }}
        className="absolute inset-0"
      >
        <img src={image} alt={title} className="w-full h-full object-cover" />
      </motion.div>
      <div className="absolute inset-0 bg-[#06271D]/65" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#06271D] to-transparent" />

      <div className="relative z-10 text-center px-6">
        <motion.span
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.8 }}
          className="inline-block font-body uppercase tracking-[0.35em] text-xs text-[var(--gold-light)] mb-5"
        >
          {eyebrow}
        </motion.span>
        <h1 className="font-display font-black text-[#F7F2E9] text-5xl md:text-8xl leading-[0.95]">
          <KineticText text={title} delay={0.6} startOnMount />
          {accent && (
            <span className="block italic gradient-text font-light">
              <KineticText text={accent} delay={0.8} startOnMount />
            </span>
          )}
        </h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1, duration: 0.8 }}
            className="text-[#F7F2E9]/70 max-w-xl mx-auto mt-6 font-light"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}
